module.exports = __webpack_public_path__ + "static/img/wonderful.1b6564e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wonderful.jpg
// module id = jhIJ
// module chunks = 1